// LessonSeparator.jsx
import React from 'react';
import './LessonSeparator.css'; // dacă ai separat CSS-ul (opțional)

const LessonSeparator = ({ text }) => (
  <div className="lesson-separator">
    <div className="lesson-separator-line" />
    <div className="lesson-separator-text">{text}</div>
    <div className="lesson-separator-line" />
  </div>
);

export default LessonSeparator;
